import { ALERTS_ENDPOINT, DEFAULT_CONFIG_ENDPOINT, DEFAULT_SESSION_ENDPOINT } from '@eucoms/common-components';

import { commonConstants } from '@config/constants/common';
import { Constants } from '@config/constants/constants.interface';

export const baseUrl = 'https://s-e-euweb-cc-bge-ui-01.azurewebsites.net';

export const constantsPattern: Constants = {
  ...commonConstants,
  isProvidingGTM: false,

  CoreServicesInitOptions: {
    configEndpoint: baseUrl + DEFAULT_CONFIG_ENDPOINT,
    sessionEndpoint: baseUrl + DEFAULT_SESSION_ENDPOINT,
    alertsEndpoint: baseUrl + ALERTS_ENDPOINT,

    additionalConfig: {
      common: {
        baseUrl,
      }
    },
  },

  devAuthHooks: [],

  paymentusUrl: 'https://comd-sit-623.paymentus.io/xotp/pm/comd',
  oPowerURLBase() {
    return sessionStorage.getItem('oPowerURLBase');
  },
};
